import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  CategoriesResponse,
  ResponseCategory,
  ResponseCategoriesResponse,
  SituationCategory,
  SituationCategoriesResponse,
} from '../../shared/models/category.models';
import { PageParams } from '../../shared/models/pagination.models';

@Injectable({ providedIn: 'root' })
export class CategoryService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  // ── Categories ────────────────────────────────────────────────────────────

  getCategories(params: PageParams = { pageSize: 10, pageIndex: 0, filter: '' }) {
    const httpParams = new HttpParams()
      .set('pageSize', params.pageSize ?? 10)
      .set('pageIndex', params.pageIndex ?? 0)
      .set('filter', params.filter ?? '');
    return this.http.get<CategoriesResponse>(`${this.apiUrl}/api/categories`, {
      params: httpParams,
    });
  }

  // ── Response Categories ───────────────────────────────────────────────────

  getResponseCategories() {
    return this.http.get<ResponseCategoriesResponse>(`${this.apiUrl}/api/response-categories`);
  }

  getResponseCategoryById(id: string) {
    return this.http.get<ResponseCategory>(`${this.apiUrl}/api/response-categories/${id}`);
  }

  createResponseCategory(payload: { name: string }) {
    return this.http.post<ResponseCategory>(`${this.apiUrl}/api/response-categories`, payload);
  }

  updateResponseCategory(payload: { id: string; name: string }) {
    return this.http.put<ResponseCategory>(`${this.apiUrl}/api/response-categories`, payload);
  }

  deleteResponseCategory(id: string) {
    return this.http.delete<void>(`${this.apiUrl}/api/response-categories/${id}`);
  }

  // ── Situation Categories ──────────────────────────────────────────────────

  getSituationCategories() {
    return this.http.get<SituationCategoriesResponse>(`${this.apiUrl}/api/situation-categories`);
  }

  getSituationCategoryById(id: string) {
    return this.http.get<SituationCategory>(`${this.apiUrl}/api/situation-categories/${id}`);
  }

  createSituationCategory(payload: { name: string }) {
    return this.http.post<SituationCategory>(`${this.apiUrl}/api/situation-categories`, payload);
  }

  updateSituationCategory(payload: { id: string; name: string }) {
    return this.http.put<SituationCategory>(`${this.apiUrl}/api/situation-categories`, payload);
  }

  deleteSituationCategory(id: string) {
    return this.http.delete<void>(`${this.apiUrl}/api/situation-categories/${id}`);
  }
}
